import { render, staticRenderFns } from "./StaticContentsPrivacyPolicy.vue?vue&type=template&id=3c38d25c&scoped=true&"
import script from "./StaticContentsPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./StaticContentsPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./StaticContentsPrivacyPolicy.vue?vue&type=style&index=0&id=3c38d25c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38d25c",
  null
  
)

export default component.exports